module.exports = __webpack_public_path__ + "img/issues-tabs-issues.f0abf028.svg";